var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveRedEye16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_red_eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666667 8C1.82 5.07333 4.66667 3 8 3C11.3333 3 14.18 5.07333 15.3333 8C14.18 10.9267 11.3333 13 8 13C4.66667 13 1.82 10.9267 0.666667 8ZM13.88 8C12.78 5.75333 10.5267 4.33333 8 4.33333C5.47333 4.33333 3.22 5.75333 2.12 8C3.22 10.2467 5.46667 11.6667 8 11.6667C10.5333 11.6667 12.78 10.2467 13.88 8ZM8 6.33333C8.92 6.33333 9.66667 7.08 9.66667 8C9.66667 8.92 8.92 9.66667 8 9.66667C7.08 9.66667 6.33333 8.92 6.33333 8C6.33333 7.08 7.08 6.33333 8 6.33333ZM5 8C5 6.34667 6.34667 5 8 5C9.65333 5 11 6.34667 11 8C11 9.65333 9.65333 11 8 11C6.34667 11 5 9.65333 5 8Z",
    fill: "#696F88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRedEye16);
export default __webpack_public_path__ + "static/media/remove-red-eye-16.7ea3adc7bf7d81e15ba440e843b59645.svg";
export { ForwardRef as ReactComponent };